module.exports = __webpack_public_path__ + "img/warning.68a3af70.svg";